import React from 'react';

import { type SsoDomain } from '@column/api';
import { DataTable, DropdownMenuItem } from '@column/ui';

import { StatusBadge, Timestamp, tableDefaults } from '~/components/Table';
import { TableActionDropdown } from '~/lib/components/table/TableActionDropdown';
import { TableTimeFormat } from '~/repositories/UserRepository';

export const DomainsTable: React.FC<{
  domains: SsoDomain[];
  onSelect: (domainId: string) => void;
  onRemove: (domain: SsoDomain) => void;
}> = ({ domains, onSelect, onRemove }) => (
  <DataTable<SsoDomain>
    {...tableDefaults}
    columns={[
      { header: 'Domain', accessor: 'domain', cell: ({ value }) => <span className="font-medium">{value}</span> },
      {
        header: 'Status',
        accessor: 'verified_at',
        cell: ({ value }) => (
          <StatusBadge tone={value ? 'success' : 'warning'}>{value ? 'Verified' : 'Pending verification'}</StatusBadge>
        ),
      },
      {
        header: 'Added',
        accessor: 'created_at',
        width: '14rem',
        cell: ({ value }) => <Timestamp date={String(value)} timeFormat={TableTimeFormat.Absolute} />,
      },
    ]}
    data={domains}
    emptyMessage="No domains linked yet."
    rowKey={(domain) => domain.id}
    onRowClick={(domain) => onSelect(domain.id)}
    rowAction={(domain) => (
      <TableActionDropdown>
        <DropdownMenuItem onSelect={() => onSelect(domain.id)}>View</DropdownMenuItem>
        <DropdownMenuItem variant="destructive" onSelect={() => onRemove(domain)}>
          Remove
        </DropdownMenuItem>
      </TableActionDropdown>
    )}
  />
);
